import React, { createContext, useState, useMemo, useCallback } from 'react';

const ItinerarySuggestionsContext = createContext();

export const ItinerarySuggestionsProvider = ({ children }) => {
  const [suggestions, setSuggestions] = useState([]);
  const colors = useMemo(() => ['#FF5733', '#33FF57', '#3357FF', '#FF33A1', '#ecf241'], []);
  const updateSuggestionsWithColors = useCallback((fetchedSuggestions) => {
    const coloredSuggestions = fetchedSuggestions.map((suggestion, index) => ({
      ...suggestion,
      markerColor: colors[index % colors.length],
    }));
    setSuggestions(coloredSuggestions);
  }, [colors]);
  return (
    <ItinerarySuggestionsContext.Provider value={{ suggestions, setSuggestions: updateSuggestionsWithColors }}>
      {children}
    </ItinerarySuggestionsContext.Provider>
  );
};

export default ItinerarySuggestionsContext;
